import script from "./KeyboardShortcutsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./KeyboardShortcutsModal.vue?vue&type=script&setup=true&lang=js"

import "./KeyboardShortcutsModal.vue?vue&type=style&index=0&id=56f0cac6&lang=scss"

const __exports__ = script;

export default __exports__